import { CampaignStatus } from 'services/campaign/types';

export enum CampaignStatusFilter {
  DRAFT = 'DRAFT',
  LIVE = 'LIVE',
  SCHEDULED = 'SCHEDULED',
  GENERATING_MESSAGES = 'GENERATING_MESSAGES',
  SENDING_MESSAGES = 'SENDING_MESSAGES',
  FINISHED_SENDING = 'FINISHED_SENDING'
}

export const statusFilterOptions = [
  CampaignStatus.DRAFT,
  CampaignStatus.LIVE,
  CampaignStatus.SCHEDULED,
  CampaignStatus.FINISHED_GENERATING,
  CampaignStatus.ARCHIVED
];

export enum CampaignFilterIds {
  needsReview = 'needsReview',
  status = 'status',
  createdBy = 'createdBy'
}
